import { render, staticRenderFns } from "./SalaryEffectAdd.vue?vue&type=template&id=9bdcf2ec&scoped=true&"
import script from "./SalaryEffectAdd.vue?vue&type=script&lang=js&"
export * from "./SalaryEffectAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdcf2ec",
  null
  
)

export default component.exports